module.exports = __webpack_public_path__ + "media/images/ccrtl-logo-eb3ad5e492ed00019d7ce6d615700966.png";